const messages = {
  "ui.modal.close.tooltip": "Close",
  "ui.modal.collapse.tooltip": "Exit full screen",
  "ui.modal.expand.tooltip": "Go full screen",
  "ui.modal.footer.cancelText": "Cancel",
  "ui.modal.footer.okText": "Okay",
  "ui.modal.minimize.disabledTooltip": "Only one form can be minimized at a time",
  "ui.modal.minimize.tooltip": "Minimize",
} as const;

export default messages;
